<div [class]="isCollapsed ? 'sidebar collapsed' : 'sidebar'">
  <div class="sidebar-header d-none d-md-flex">
    <img src="{{isCollapsed ? 'assets/images/logo.svg' : 'assets/images/logo-full.svg'}}" alt="Logo" class="logo">
    <button class="collapse-btn" (click)="toggleSidebar()">
      <i [class]="isCollapsed ? 'fas fa-angle-right' : 'fas fa-angle-left'"></i>
    </button>
  </div>
  
  <div class="sidebar-menu">
    <a routerLink="/profile" routerLinkActive="active" class="menu-item">
      <i class="fas fa-user"></i>
      <span [class.d-none]="isCollapsed">Profile</span>
    </a>
    <!-- <a routerLink="/projects" routerLinkActive="active" class="menu-item">
      <i class="fas fa-sheet-plastic"></i>
      <span [class.d-none]="isCollapsed">Projects</span>
    </a>
    <a routerLink="/timesheet" routerLinkActive="active" class="menu-item">
      <i class="fas fa-clock"></i>
      <span [class.d-none]="isCollapsed">Timesheet</span>
    </a> -->
    <a routerLink="/my-team" routerLinkActive="active" class="menu-item" *ngIf="isManager">
      <i class="fas fa-users"></i>
      <span [class.d-none]="isCollapsed">My Team</span>
    </a>
    <a routerLink="/timesheet" routerLinkActive="active" class="menu-item">
      <i class="fas fa-clock"></i>
      <span [class.d-none]="isCollapsed">Timesheet</span>
    </a>
  </div>

  <div class="user-profile d-none d-md-block">
    <div class="profile-info" (click)="toggleDropdown($event)">
      <div class="avatar">
        <span>{{userName | avatarInitial}}</span>
      </div>
      <div class="user-details" [class.d-none]="isCollapsed">
        <span class="name">{{userName}}</span>
        <i class="fas fa-chevron-down"></i>
      </div>
    </div>
    
    @if(showDropdown){
      <div class="dropdown-menu">
        <div class="dropdown-item" (click)="logout()">
          <i class="fas fa-sign-out-alt"></i>
          <span>Logout</span>
        </div>
      </div>
    }
  </div>
</div>